document.addEventListener('DOMContentLoaded', function () {

    // ========== 1) 绑定变体切换，更新价格/对比价/库存/图片 ==========
    function updateAccessoryDisplayForBlock(blockEl) {
        if (!blockEl) return;
        var handle = blockEl.dataset.accessoryHandle || blockEl.querySelector('.accessory-item')?.dataset.productHandle;
        if (!handle) return;
        var map = window.accessoryVariants && window.accessoryVariants[handle];
        if (!map) return;

        var select = blockEl.querySelector('.accessory-variant');
        var selectedId = select ? select.value : (Object.keys(map)[0] || null);
        if (!selectedId) return;

        var info = map[selectedId];
        if (!info) return;

        var priceEl = blockEl.querySelector('.accessory-price');
        var compareEl = blockEl.querySelector('.accessory-compare');
        var stockEl = blockEl.querySelector('.accessory-stock-status');
        var imgEl = blockEl.querySelector('.accessory-image-img');

        if (priceEl) priceEl.innerHTML = info.price_html || '';
        if (compareEl) {
            if (info.compare_at_price && Number(info.compare_at_price) > 0) {
                compareEl.style.display = '';
                compareEl.innerHTML = '<s>' + (info.compare_at_price_html || '') + '</s>';
            } else {
                compareEl.style.display = 'none';
                compareEl.innerHTML = '';
            }
        }
        if (stockEl) {
            stockEl.innerHTML = info.available
                ? '<span class="in-stock">In stock</span>'
                : '<span class="out-stock">Out of stock</span>';
        }
        if (imgEl && info.image) {
            imgEl.src = info.image;
        }
    }

    // 绑定每个 accessory-block 的 select change & 初始触发
    document.querySelectorAll('.accessory-block').forEach(function (blockEl) {
        var sel = blockEl.querySelector('.accessory-variant');
        if (sel) {
            sel.addEventListener('change', function () { updateAccessoryDisplayForBlock(blockEl); });
            updateAccessoryDisplayForBlock(blockEl);
        } else {
            updateAccessoryDisplayForBlock(blockEl);
        }
    });

    // 如果页面动态注入 accessory-block，可监听新增并绑定
    (function () {
        var container = document.querySelector('.accessory-block') && document.querySelector('.accessory-block').parentNode;
        if (!container) return;
        var mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                m.addedNodes && m.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1 && node.matches('.accessory-block')) {
                        var sel = node.querySelector('.accessory-variant');
                        if (sel) {
                            sel.addEventListener('change', function () { updateAccessoryDisplayForBlock(node); });
                            updateAccessoryDisplayForBlock(node);
                        } else {
                            updateAccessoryDisplayForBlock(node);
                        }
                    }
                });
            });
        });
        mo.observe(container, { childList: true, subtree: true });
    })();

    // ========== 2) 数量 + / - 控件与输入校验 ==========
    document.querySelectorAll('.accessory-block').forEach(function (item) {
        var dec = item.querySelector('.qty-decrease');
        var inc = item.querySelector('.qty-increase');
        var input = item.querySelector('.qty-input');

        if (input) {
            if (input.value === '' || input.value === null) input.value = 0;
            input.addEventListener('input', function () {
                var v = parseInt(input.value, 10);
                if (isNaN(v) || v < 0) v = 0;
                input.value = v;
            });
        }

        dec && dec.addEventListener('click', function () {
            if (!input) return;
            input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
            input.dispatchEvent(new Event('input', { bubbles: true }));
        });

        inc && inc.addEventListener('click', function () {
            if (!input) return;
            input.value = (parseInt(input.value, 10) || 0) + 1;
            input.dispatchEvent(new Event('input', { bubbles: true }));
        });
    });

    // ========== 3) AJAX 单个加入（用于导出函数） ==========
    function addToCartAjax(variantId, quantity) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
        }).then(function (r) {
            if (!r.ok) return r.text().then(function (t) { throw new Error(t) });
            return r.json();
        });
    }

    // ========== 4) 读取页面上已选择的配件 (id, qty) ==========
    function getSelectedAccessories() {
    var items = [];

    document.querySelectorAll('.accessory-block').forEach(function (item) {
        // 检查该 accessory-block 是哪种复选框类型
        var checkbox = item.querySelector('.product_choose_checkbox') || 
                       item.querySelector('.accessory_left_checkbox');

        // 没有复选框或者未激活，跳过
        if (!checkbox || !checkbox.classList.contains('active')) return;

        // 获取数量
        var qtyElem = item.querySelector('.qty-input');
        var qty = qtyElem ? (parseInt(qtyElem.value, 10) || 0) : 0;
        if (qty <= 0) return;

        // 获取变体 ID
        var variantElem = item.querySelector('.accessory-variant');
        var variantId = variantElem ? variantElem.value : null;
        if (!variantId) return;

        items.push({ id: variantId.toString(), quantity: qty });
    });

    return items;
}


    // ========== 5) 导出：把已选配件以 AJAX 加入购物车 ==========
    window.addSelectedAccessoriesToCart = function (options) {
        options = options || {};
        var mode = options.mode === 'serial' ? 'serial' : 'parallel';
        var accessories = getSelectedAccessories();

        if (!accessories || accessories.length === 0) {
            return Promise.resolve({ message: 'no_accessories_selected' });
        }

        if (mode === 'parallel') {
            var promises = accessories.map(function (it) { return addToCartAjax(it.id, it.quantity); });
            return Promise.all(promises).then(function (results) {
                return { message: 'ok', results: results };
            });
        } else {
            return accessories.reduce(function (p, it) {
                return p.then(function (acc) {
                    return addToCartAjax(it.id, it.quantity).then(function (res) {
                        acc.push(res);
                        return acc;
                    });
                });
            }, Promise.resolve([])).then(function (results) {
                return { message: 'ok', results: results };
            });
        }
    };

    window.addSelectedAccessoriesToCartThen = function (callback, options) {
        return window.addSelectedAccessoriesToCart(options).then(function (res) {
            if (typeof callback === 'function') callback(null, res);
            return res;
        }).catch(function (err) {
            if (typeof callback === 'function') callback(err);
            throw err;
        });
    };

    // ========== 6) 注入配件到主表单（items[][id], items[][quantity]）在提交前调用 ==========
    var productForms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[action^="/cart/add"]');

    function removeInjectedAccessoryInputs(form) {
        if (!form) return;
        var injected = form.querySelectorAll('.injected-accessory-input');
        injected.forEach(function (el) { el.remove(); });
    }

    function injectAccessoriesIntoForm(form, accessories) {
        if (!form) return;
        removeInjectedAccessoryInputs(form);
        if (!accessories || accessories.length === 0) return;

        accessories.forEach(function (a) {
            var inputId = document.createElement('input');
            inputId.type = 'hidden';
            inputId.name = 'items[][id]';
            inputId.value = a.id;
            inputId.className = 'injected-accessory-input';

            var inputQty = document.createElement('input');
            inputQty.type = 'hidden';
            inputQty.name = 'items[][quantity]';
            inputQty.value = String(a.quantity);
            inputQty.className = 'injected-accessory-input';

            form.appendChild(inputId);
            form.appendChild(inputQty);
        });
    }

    function prepareAndInject(ev) {
        try {
            var form = ev.currentTarget.closest('form');
            var accessories = getSelectedAccessories();
            injectAccessoriesIntoForm(form, accessories);
        } catch (e) {
            console.error('inject accessories failed', e);
        }
    }

    productForms.forEach(function (form) {
        form.addEventListener('submit', prepareAndInject);
        var submitButtons = form.querySelectorAll('[type="submit"], .product-form__submit');
        submitButtons.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                prepareAndInject({ currentTarget: form });
            });
        });
    });

    window.addEventListener('beforeunload', function () {
        productForms.forEach(removeInjectedAccessoryInputs);
    });

    window.injectAccessoriesIntoMainForm = function () {
        productForms.forEach(function (form) {
            injectAccessoriesIntoForm(form, getSelectedAccessories());
        });
    };

    console.info('Accessory block loaded: variant price/compare/image/stock updates + qty UI + inject/add functions.');
});
